import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import { Box } from "src/components/MuiGenerals";
import { useTranslation } from "src/hooks";
import ContractSweepRecipient from "./ContractSweepRecipient";
import ContractSweepRecipientGroup from "./ContractSweepRecipientGroup";

const ContractSweepRecipientSetting = () => {
  const [tabsIndex, setTabsIndex] = useState(0);
  const tabs = [
    {
      name: "contract_sweep_recipient_group",
      path: "",
      jsxNode: <ContractSweepRecipientGroup />,
    },
    {
      name: "contract_sweep_recipient",
      path: "",
      jsxNode: <ContractSweepRecipient />,
    },
  ];
  const { t } = useTranslation("contractSweepRecipientSetting");
  return (
    <Box
      sx={{
        backgroundColor: "white",
        paddingTop: "2rem",
      }}>
      <Tabs
        sx={{ margin: "0 1.5rem", borderBottom: "solid #E1E4EA 1px" }}
        value={tabsIndex}
        onChange={(_, tabsEnum) => setTabsIndex(tabsEnum)}>
        {tabs.map((item, index) => {
          const name = (
            <Box sx={{ display: "flex", gap: "0.2rem", alignItems: "center" }}>
              {t(item.name)}
            </Box>
          );
          return <Tab key={index} label={name} {...a11yProps(index)} />;
        })}
      </Tabs>
      {tabs.map((item, index) => {
        return (
          <div
            key={index}
            role="tabpanel"
            hidden={tabsIndex !== index} //hidden all if no index==value
            id={`simple-tabpanel-${index}`} //showing which tab
            aria-labelledby={`simple-tab-${index}`}>
            {tabsIndex === index && item.jsxNode}
          </div>
        );
      })}
    </Box>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export default ContractSweepRecipientSetting;
